import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const COUNTRIES = [
    { code: "GB", label: "United Kingdom" },
    { code: "IE", label: "Ireland" },
    { code: "FR", label: "France" },
    { code: "DE", label: "Germany" },
    { code: "IT", label: "Italy" },
    { code: "ES", label: "Spain" },
    { code: "PT", label: "Portugal" },
    { code: "NL", label: "Netherlands" },
    { code: "BE", label: "Belgium" },
    { code: "DK", label: "Denmark" },
    { code: "SE", label: "Sweden" },
    { code: "NO", label: "Norway" },
    { code: "FI", label: "Finland" },
    { code: "PL", label: "Poland" },
    { code: "CZ", label: "Czech Republic" },
    { code: "AT", label: "Austria" },
    { code: "CH", label: "Switzerland" },
    { code: "GR", label: "Greece" },
    { code: "HU", label: "Hungary" },
    { code: "RO", label: "Romania" },
    { code: "US", label: "United States" },
    { code: "CA", label: "Canada" },
    { code: "MX", label: "Mexico" },
    { code: "JP", label: "Japan" },
    { code: "CN", label: "China" },
    { code: "IN", label: "India" },
    { code: "AU", label: "Australia" },
    { code: "NZ", label: "New Zealand" },
    { code: "TR", label: "Turkey" },
    { code: "MA", label: "Morocco" },
];
export function CountrySelect({ value, onChange, }) {
    return (_jsxs("select", { className: "h-8 rounded-sm border border-ink-200 bg-paper px-2 text-body-sm text-ink-900", value: value ?? "", onChange: (e) => onChange(e.target.value === "" ? null : e.target.value), children: [_jsx("option", { value: "", children: "\u2014" }), COUNTRIES.map(({ code, label }) => (_jsx("option", { value: code, children: label }, code)))] }));
}
